import { createOnlineStoresBiLogger } from './bi.utils';
import { CheckoutService } from './CheckoutService';
import { SiteStore } from '../site-store/SiteStore';
import { createExports } from './Exports/createExports';
import { OnlineStoresSettingsService } from './OnlineStoresSettingsService';
export function createViewerScript() {
    var context = {};
    return {
        initAppForPage: function (initParams, _apis, wixAPI, platformServices) {
            context.wixAPI = wixAPI;
            context.experiments = platformServices.essentials.experiments;
            context.errorHandler = platformServices.essentials.errorHandler;
            context.httpClient = platformServices.essentials.httpClient;
            context.initParams = initParams;
            context.checkoutService = new CheckoutService(context);
            context.biLogger = createOnlineStoresBiLogger(wixAPI, platformServices);
            context.trackEvent = wixAPI.window.trackEvent;
            context.siteStore = new SiteStore(initParams, _apis, wixAPI, platformServices);
            context.platformServices = platformServices;
            context.onlineStoresPropertiesService = new OnlineStoresSettingsService({
                instance: initParams.instance,
                wixCodeApi: wixAPI,
                csrfToken: platformServices.getCsrfToken(),
                essentials: platformServices.essentials,
                storeId: initParams.instanceId,
                isSSR: wixAPI.window.rendering.env === 'backend',
                experiments: platformServices.essentials.experiments,
                getStoreCountry: function () { return context.siteStore.storeCountry; },
                getStoreLanguage: function () { return context.siteStore.storeLanguage; },
                storage: _apis.storage,
                windowApis: wixAPI.window,
                isSiteMode: function () { return wixAPI.window.viewMode === 'Site'; },
            });
            return Promise.resolve();
        },
        createControllers: function () { return null; },
        exports: createExports({ context: context, origin: 'wixcode' }),
    };
}
//# sourceMappingURL=viewerScript.js.map